import React from 'react';

const MasterCardIcon = ({size = 24}) => (
  <svg width={size} height={size} role="presentation" fill="none" viewBox="0 0 20 20">
    <path fill="#FF5A00" d="M7.3 5.3h5.4v9.64H7.3V5.3Z"/>
    <path fill="#EB001B"
          d="M7.65 10.12c0-1.95.92-3.69 2.35-4.81A6.18 6.18 0 0 0 6.18 4 6.15 6.15 0 0 0 0 10.12a6.15 6.15 0 0 0 6.18 6.13c1.45 0 2.77-.5 3.82-1.31a6.09 6.09 0 0 1-2.35-4.82Z"
    />
    <path fill="#F79E1B"
          d="M20 10.12a6.15 6.15 0 0 1-6.18 6.13c-1.45 0-2.77-.5-3.82-1.31a6.11 6.11 0 0 0 0-9.63A6.18 6.18 0 0 1 13.82 4 6.16 6.16 0 0 1 20 10.12Z"
    />
  </svg>
);

export default MasterCardIcon;
